import { render } from "./workersNew.vue?vue&type=template&id=65686d34&scoped=true"
import script from "./workersNew.vue?vue&type=script&lang=js"
export * from "./workersNew.vue?vue&type=script&lang=js"

import "./workersNew.vue?vue&type=style&index=0&id=65686d34&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65686d34"]])

export default __exports__